import React from "react";
import {
  FaCogs,
  FaDraftingCompass,
  FaLock,
  FaExpandArrowsAlt,
  FaSyncAlt,
  FaHeadset,
} from "react-icons/fa";

function WhyChooseXeerDev() {
  const reasons = [
    {
      title: "Comprehensive Tech Stack",
      desc: "Our blockchain engineers command elite proficiency in Solidity, Substrate, and Cosmos guaranteeing multi-chain capability.",
      icon: <FaCogs size={35} />,
    },
    {
      title: "Customized Solutions",
      desc: "Every protocol is precision-engineered reflecting distinct functional objectives driving optimized yields autonomously.",
      icon: <FaDraftingCompass size={35} />,
    },
    {
      title: "Security Through Rigor",
      desc: "We prioritize defensive architecture comprehensively auditing all autonomous execution lines securing billion-dollar liquidities.",
      icon: <FaLock size={35} />,
    },
    {
      title: "Scalable Deployments",
      desc: "Our modular paradigms easily scale dynamically absorbing monumental traction effortlessly without compromising efficiency.",
      icon: <FaExpandArrowsAlt size={35} />,
    },
    {
      title: "End-To-End Services",
      desc: "From blueprinting to mainnet deployments and upgrades, we flawlessly coordinate all full-cycle ecosystem developments.",
      icon: <FaSyncAlt size={35} />,
    },
    {
      title: "Post-Launch Support",
      desc: "Achieve complete peace of mind through dedicated maintenance strictly supporting continuous Web3 protocol optimizations.",
      icon: <FaHeadset size={35} />,
    },
  ];

  return (
    <div
      className="services-area pt-120 pb-120 mt-5"
      style={{ background: "#ffffff" }}
    >
      <div className="container text-center">
        <h2 className="title fw-extrabold mb-4">Why Choose Xeer Technology?</h2>

        <p
          className="mt-2 mb-5 mx-auto text-muted fs-5"
          style={{ maxWidth: "800px" }}
        >
          As decentralized development vanguards, our technically astute
          developers consistently synthesize complex enterprise requirements.
        </p>

        <div className="row g-4 justify-content-center">
          {reasons.map((reason, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="reason-card border-0 p-5 text-center h-100"
                style={{
                  borderRadius: "32px",
                  background: "#f9faff",
                  border: "1px solid #f0f3ff",
                  transition: "all 0.4s ease",
                  cursor: "default",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.background = "#ffffff";
                  e.currentTarget.style.boxShadow =
                    "0 25px 50px rgba(0, 0, 0, 0.04)";
                  e.currentTarget.style.borderColor = "#3366ff20";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "#f9faff";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#f0f3ff";
                }}
              >
                <div
                  className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                  style={{
                    width: "70px",
                    height: "70px",
                    fontSize: "28px", // untouched
                    backgroundColor: "#ffffff",
                    color: reason.color,
                    borderRadius: "20px",
                    boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
                  }}
                >
                  {reason.icon}
                </div>

                <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
                  {reason.title}
                </h5>

                <p
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    lineHeight: "1.7",
                    marginBottom: 0,
                  }}
                >
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WhyChooseXeerDev;
